import {NgModule} from "@angular/core";
import {TooltipComponent} from "./tooltip.component";
import {PopupModule} from "@progress/kendo-angular-popup";
import {CPTranslateModule} from "../../../translate";
import {ClickOutModule} from "../../directives/click.out/click.out.module";
import {CommonModule} from "@angular/common";

@NgModule({
	declarations:[TooltipComponent],
	imports:[PopupModule, CPTranslateModule, ClickOutModule, CommonModule],
	exports:[TooltipComponent]
})
export class CPTooltipModule{

}
